<script setup lang="ts">
import NewsThumb from '../thumb/NewsThumb.vue'
import ItemsSlider from '~/components/global/ItemsSlider.vue'
import Container from '~/components/layout/Container.vue'
import { useAPIRequest } from '~/composables/api/useAPIRequest'
import type { Article, ArticlesResponse } from '~/types/api/Article'

const props = defineProps<{
  article: Article
}>()

/**
 * TODO: Do we want some special logic, or is that okay?
 *
 * This will get random tag from tags, that article is in
 * and fetch latest articles from there
 */
const { data } = await useAsyncData<ArticlesResponse>(async () => {
  let newsApiPath = '/articles/filter/section_id/1'

  if (props.article.tags.length) {
    const tags = props.article.tags
    const randomTagIndex = Math.floor(Math.random() * tags.length)
    const randomTagId = tags[randomTagIndex].id

    newsApiPath = `/articles/filter/tag_id/${randomTagId}`
  }

  return await useAPIRequest(newsApiPath)
})

const slides =
  data.value?.data
    ?.filter((item) => item.id !== props.article.id)
    .slice(0, 3) || []

const hasSlides = slides?.length > 0
</script>

<template>
  <Container v-if="hasSlides">
    <div class="c-news-detail-recommended">
      <h2 class="c-news-detail-recommended__title h2">
        {{ $t('pages.news.detail.sliderTitle') }}
      </h2>

      <div class="c-news-detail-recommended__content">
        <ItemsSlider slider-id="news-detail-slider">
          <SwiperSlide v-for="item in slides" :key="item.id">
            <NewsThumb :article="item" />
          </SwiperSlide>
        </ItemsSlider>
      </div>
    </div>
  </Container>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-news-detail-recommended {
  padding-top: 70px;
  border-top: 1px solid var(--color-border);

  @include breakpoint-down('sm') {
    padding-top: 48px;
  }

  &__title {
    margin-bottom: 64px;
    text-align: center;
    line-height: 1;

    @include breakpoint-down('sm') {
      font-size: 32px;
      margin-bottom: 40px;
    }
  }
}
</style>
